import { render, staticRenderFns } from "./NotifyAClaim.vue?vue&type=template&id=67f0c9f0&"
import script from "./NotifyAClaim.vue?vue&type=script&lang=js&"
export * from "./NotifyAClaim.vue?vue&type=script&lang=js&"
import style0 from "./NotifyAClaim.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports